'use strict';

/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;



/*****************
 ** WEBPACK FOOTER
 ** ./~/call-bind-apply-helpers/reflectApply.js
 ** module id = 187
 ** module chunks = 0
 **/